import { useState } from 'react';
import { toast } from 'react-toastify';
import { useLoaderStore } from '../../../stores/loader.store';
import { ConfirmationModal } from '../../../shared/components/Modal/ConfirmationModal';
import cloudUpload from "../../../assets/Images/cloud-upload.png";
import moderationFailedThankYouService from '../../../Services/moderation-failed-thankyou.service';

export function ReleaseModerationFailedGift({ moderationFailedGift, onReleaseSuccess }) {
    const setShowLoader = useLoaderStore((state) => state.setShowLoader);
    const [message, setMessage] = useState(moderationFailedGift.message);
    const [showConfirmation, setShowConfirmation] = useState(false);

    async function handleReleaseMessage() {
        setShowLoader(true);

        let data = {
            draftGiftId: moderationFailedGift._id,
            message: message
        };
        try {
            const res = await moderationFailedThankYouService.releaseModerationFailedGift(data);
            if (res.status === 200) {
                toast.success("Successfully released moderation failed gift");
                onReleaseSuccess();
                return;
            }

            toast.error("Couldn't release moderation failed gift");
        } catch (err) {
            console.log(err);
            toast.error("Couldn't release moderation failed thankyou");
        } finally {
            setShowLoader(false);
        }
    }

    return (
        <div style={{ minWidth: '600px', maxWidth: '1000px', maxHeight: '1000px', overflowY: "auto" }} className='p-2'>
            <div className="mb-2">
                <div className="mb-2">
                    <label className="cstm-label">Edit Message (Optional)</label>
                    <textarea
                        type="text"
                        className="cstm-input-moderation-field"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                    />
                </div>
            </div>

            <div className="d-flex justify-content-end">
                <button type='button' className='cstm-submitbutton' onClick={() => setShowConfirmation(true)}>Release</button>
            </div>

            {showConfirmation &&
                <ConfirmationModal
                    text='Are you sure you want to release this thank you gift message?'
                    confirmBtnText='Release'
                    imgSrc={cloudUpload}
                    onConfirm={handleReleaseMessage}
                    onCancel={() => setShowConfirmation(false)}
                />}
        </div>
    );
}